import React from "react";

const ProfileContext = React.createContext({
  profile: {},
  setProfile: () => {},
});

export default ProfileContext;
